import React, { useState } from 'react'
import { toast } from '@CommonComponents/toast'
import { useStateValue } from '@State'
import { codeOrderManagement as endpoints } from '@URLS'
import { client } from '@Utils'

export const CodeContainer = ({
  id,
  code,
  created,
  expiration,
  assigned,
  assignedTo,
  assignedCourse,
  redeemedOn,
  redeemedBy,
  redeemedCourse,
  status,
  notes,
  orderId,
}) => {
  let [currentState, dispatch] = useStateValue()
  let [editRedeemedOn, setEditRedeemedOn] = useState(false)
  let [localRedeemedOn, setLocalRedeemedOn] = useState(false)
  let [redeemedOnUpdated, setRedeemedOnUpdated] = useState(false)
  let [editNotes, setEditNotes] = useState(false)
  let [localNotes, setLocalNotes] = useState(notes || '')
  let [notesUpdated, setNotesUpdated] = useState(false)
  let [open, setOpen] = useState(false)

  const formatText = text => {
    if (text) {
      return <b>{text}</b>
    } else {
      return <i className="text-muted">None</i>
    }
  }

  const getLabelClass = status => {
    if (status === 'Redeemed') {
      return 'label-success'
    } else {
      return 'label-warning'
    }
  }

  const disableCode = async () => {
    let codeData = {
      couponId: id
    }
    try {
      let resp = await client.post(endpoints.expireCode(), codeData)
      toast.success(`${resp.data.message} Refresh to see the change.`)
    } catch (err) {
      console.error(err)
      toast.error(
        `There was an error trying to expire the code. ${err}`
      )
    }
  }

  const updateCode = async (attrName, value, setFieldFunc, setUpdatedFunc) => {
    let data = {
      orderId: orderId,
      couponId: id,
      attrName: attrName,
      value: value,
    }
    try {
      let resp = await client.post(endpoints.updateCoupon(), data)
      let codes = currentState.codes
      let couponId = resp.data.code.id
      for (let i = 0; i < codes.length; i++) {
        if (codes[i].id === couponId) {
          codes[i] = resp.data.code
        }
      }

      dispatch({
        type: 'updateCodes',
        payload: codes,
      })
      if (setFieldFunc) {
        setFieldFunc(false)
      }
      if (setUpdatedFunc) {
        setUpdatedFunc(false)
      }
    } catch (err) {
      console.error(err)
      toast.error(`There was an error while updating the coupon status. ${err}`)
    }
  }

  const getEditIconClasses = () => {
    return 'far fa-edit ml-3 pointer'
  }

  const toggleInputEdit = (setter, value) => {
    setter(!value)
  }

  const updateLocalVal = (updater, val, updatedSetter) => {
    updater(val)
    updatedSetter(true)
  }

  const rejectLocalEdit = (setEdit, setLocalVal, val) => {
    setEdit(false)
    setLocalVal(val)
  }

  const calcMinW = () => {
    if (redeemedOn && redeemedCourse) {
      return 20
    } else if (redeemedOn) {
      return 25
    } else {
      return 33
    }
  }

  return (
    <div className={`card-myed`}>
      <div className="d-flex justify-content-between align-items-center">
        <div style={{ minWidth: `${calcMinW()}` }}>
          <span>
            <b>{code}</b>
          </span>
        </div>
        <div style={{ minWidth: `${calcMinW()}` }}>
          <span>
            {status === 'Active' ? (
              <i className="text-muted">Not yet redeemed</i>
            ) : (
              <span className={`label ${getLabelClass(status)}`}>{status}</span>
            )}
          </span>
        </div>
        {redeemedOn && (
          <div style={{ minWidth: `${calcMinW()}` }}>
            <span>{redeemedOn}</span>
          </div>
        )}
        {redeemedCourse && (
          <div style={{ minWidth: `${calcMinW()}` }}>
            <span>
              <a href={`/reader/web/${redeemedCourse}/`}>{redeemedCourse}</a>
            </span>
          </div>
        )}
        <div className="text-right" style={{ minWidth: `${calcMinW()}` }}>
          <a onClick={() => setOpen(!open)}>{open ? 'Close' : 'Detail'}</a>
        </div>
      </div>
      {open && (
        <div>
          <div className="m-4">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <input
                  type="checkbox"
                  name="active"
                  checked={status === 'Active'}
                  onChange={e => updateCode('status', e.target.name, null, null)}
                />
                <span className="mr-5 ml-3">Unredeemed</span>
                <input
                  type="checkbox"
                  name="returned"
                  checked={status === 'Returned'}
                  onChange={e => updateCode('status', e.target.name, null, null)}
                />
                <span className="mr-5 ml-3">Returned</span>
                <input
                  type="checkbox"
                  name="redeemed"
                  checked={status === 'Redeemed'}
                  onChange={e => updateCode('status', e.target.name, null, null)}
                />
                <span className="ml-3">Redeemed</span>
              </div>
              <button
                className="btn btn-myed btn-sm-myed btn-default-myed btn-default ml-4"
                onClick={() => disableCode()}
              >
                Expire/disable this code
              </button>
            </div>
          </div>
          <div className="d-flex bg-light px-5 py-3 align-items-baseline">
            <div className="w-50">
              <table>
                <tbody>
                  <tr>
                    <td className="text-muted text-right">Redeemed on:</td>
                    {editRedeemedOn ? (
                      <td className="py-2">
                        &nbsp;&nbsp;&nbsp;
                        <input
                          type="date"
                          required
                          name="pmtDate"
                          value={localRedeemedOn}
                          onChange={e =>
                            updateLocalVal(
                              setLocalRedeemedOn,
                              e.target.value,
                              setRedeemedOnUpdated
                            )
                          }
                        />
                        {redeemedOnUpdated && (
                          <i
                            className="fa-regular fa-check ml-3 pointer"
                            onClick={() =>
                              updateCode(
                                'redeemed',
                                localRedeemedOn,
                                setEditRedeemedOn,
                                setRedeemedOnUpdated
                              )
                            }
                          />
                        )}
                        <i
                          className="fa-regular fa-times ml-3 pointer"
                          onClick={() =>
                            rejectLocalEdit(
                              setEditRedeemedOn,
                              setLocalRedeemedOn,
                              redeemedOn
                            )
                          }
                        />
                      </td>
                    ) : (
                      <td className="py-2">
                        &nbsp;&nbsp;&nbsp;{formatText(redeemedOn)}
                        <i
                          className={getEditIconClasses()}
                          onClick={() =>
                            toggleInputEdit(setEditRedeemedOn, editRedeemedOn)
                          }
                        />
                      </td>
                    )}
                  </tr>
                  <tr>
                    <td className="text-muted text-right">Redeemed by:</td>
                    <td className="py-2">
                      &nbsp;&nbsp;&nbsp;{formatText(redeemedBy)}
                    </td>
                  </tr>
                  <tr>
                    <td className="text-muted text-right">Redeemed course:</td>
                    <td className="py-2">
                      &nbsp;&nbsp;&nbsp;{formatText(redeemedCourse)}
                    </td>
                  </tr>
                  <tr>
                    <td className="text-muted text-right" style={{ verticalAlign: 'top' }}>Notes:</td>
                    {editNotes ? (
                      <td className="py-2">
                        &nbsp;&nbsp;&nbsp;
                        <textarea
                          rows="3"
                          cols="30"
                          value={localNotes}
                          onChange={e =>
                            updateLocalVal(
                              setLocalNotes,
                              e.target.value,
                              setNotesUpdated
                            )
                          }
                        />
                        {notesUpdated && (
                          <i
                            className="fa-regular fa-check ml-3 pointer"
                            onClick={() =>
                              updateCode(
                                'notes',
                                localNotes,
                                setEditNotes,
                                setNotesUpdated
                              )
                            }
                          />
                        )}
                        <i
                          className="fa-regular fa-times ml-3 pointer"
                          onClick={() =>
                            rejectLocalEdit(
                              setEditNotes,
                              setLocalNotes,
                              notes || ''
                            )
                          }
                        />
                      </td>
                    ) : (
                      <td className="py-2">
                        &nbsp;&nbsp;&nbsp;{formatText(notes)}
                        <i
                          className={getEditIconClasses()}
                          onClick={() =>
                            toggleInputEdit(setEditNotes, editNotes)
                          }
                        />
                      </td>
                    )}
                  </tr>
                </tbody>
              </table>
            </div>
            <div>
              <table>
                <tbody>
                  <tr>
                    <td className="text-muted text-right">Created:</td>
                    <td className="py-2">
                      &nbsp;&nbsp;&nbsp;{formatText(created)}
                    </td>
                  </tr>
                  <tr>
                    <td className="text-muted text-right">Expiration:</td>
                    <td className="py-2">
                      &nbsp;&nbsp;&nbsp;{formatText(expiration)}
                    </td>
                  </tr>
                  <tr>
                    <td className="text-muted text-right">Assigned on:</td>
                    <td className="py-2">
                      &nbsp;&nbsp;&nbsp;{formatText(assigned)}
                    </td>
                  </tr>
                  <tr>
                    <td className="text-muted text-right">Assigned org:</td>
                    <td className="py-2">
                      &nbsp;&nbsp;&nbsp;{formatText(assignedTo)}
                    </td>
                  </tr>
                  <tr>
                    <td className="text-muted text-right">Assigned course:</td>
                    <td className="py-2">
                      &nbsp;&nbsp;&nbsp;{formatText(assignedCourse)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
